module.exports = __webpack_public_path__ + "static/media/tpn-ce-wire-2.7310fd96.png";